// frontend/src/components/landing/icons.js
import React from 'react';

// Line icons on a 24px grid, one stroke width, coloured by currentColor
const Icon = ({ size = 24, children, ...rest }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
        {...rest}
    >
        {children}
    </svg>
);

export const UploadIcon = (props) => (
    <Icon {...props}>
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
        <path d="M14 3v5h5" />
        <path d="M12 17v-6" />
        <path d="m9.5 13.5 2.5-2.5 2.5 2.5" />
    </Icon>
);

export const LabelIcon = (props) => (
    <Icon {...props}>
        <path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z" />
        <circle cx="8" cy="8" r="1.5" />
    </Icon>
);

export const ChartIcon = (props) => (
    <Icon {...props}>
        <path d="M4 20V4" />
        <path d="M4 20h16" />
        <path d="M8 16v-5" />
        <path d="M12 16V8" />
        <path d="M16 16v-3" />
    </Icon>
);

export const ArrowRightIcon = (props) => (
    <Icon {...props}>
        <path d="M5 12h14" />
        <path d="m13 6 6 6-6 6" />
    </Icon>
);

export const ArrowUpIcon = (props) => (
    <Icon {...props}>
        <path d="M12 19V5" />
        <path d="m6 11 6-6 6 6" />
    </Icon>
);

export const MenuIcon = (props) => (
    <Icon {...props}>
        <path d="M4 7h16" />
        <path d="M4 12h16" />
        <path d="M4 17h16" />
    </Icon>
);

export const CloseIcon = (props) => (
    <Icon {...props}>
        <path d="M6 6l12 12" />
        <path d="M18 6 6 18" />
    </Icon>
);
